import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Immutable from 'immutable';
import { viewGet } from '@uncinc/react-drupal-core/dist/redux/actions/Entity/View';

import {
  SELECTED_ENTITIES_SIZE_SMALL,
  SELECTED_ENTITIES_SIZE_LARGE
} from '../../config/constants';

import SelectedEntities from '../SelectedEntities';
import LandingSelectedEntities from '../LandingSelectedEntities';

const ENTITIES_VIEW_BLOCK = 'highlighted';

const CombinedHighlightedEntities = ({ isLargeVariant = false, contentProps, selectedEntities, viewDisplay, viewFilters, viewArgs = [] }) => {
  const dispatch = useDispatch();
  const [renderableEntities, setRenderableEntities] = useState(Immutable.List());
  const [entitiesLoaded, setEntitiesLoaded] = useState(false);

  const viewData = useSelector((state) => state.getIn(['view', viewDisplay, ENTITIES_VIEW_BLOCK], null));
  const renerableEntitiesSize = isLargeVariant ? SELECTED_ENTITIES_SIZE_LARGE : SELECTED_ENTITIES_SIZE_SMALL;
  const RenderableEntitiesComponent = isLargeVariant ? LandingSelectedEntities : SelectedEntities
  const shouldFetchAdditionalEntities = selectedEntities.size < renerableEntitiesSize;

  // Combine the received View entities with the selected ones.
  useEffect(() => {
    if (viewData && renderableEntities.size === 0) {
      let combinedEntities = selectedEntities.merge(viewData.get('entities', Immutable.List()))
      // Max sure we don't exceed our max.
      combinedEntities = combinedEntities.slice(0, renerableEntitiesSize)
      // We are ready to render.
      setRenderableEntities(combinedEntities);
      setEntitiesLoaded(true);
    }
  }, [viewData, selectedEntities, renerableEntitiesSize, setRenderableEntities, setEntitiesLoaded]);

  // Check if need to fetch additional entities, or if we can render.
  useEffect(() => {
    if (!entitiesLoaded) {
      if (shouldFetchAdditionalEntities) {
        setRenderableEntities(Immutable.List());
        dispatch(viewGet(viewDisplay, ENTITIES_VIEW_BLOCK, 0, viewArgs, viewFilters));
      } else {
        setRenderableEntities(selectedEntities);
        setEntitiesLoaded(true);
      }
    }
  }, [entitiesLoaded, shouldFetchAdditionalEntities, viewGet, ENTITIES_VIEW_BLOCK, setRenderableEntities, setEntitiesLoaded]);

  return (entitiesLoaded && renderableEntities.size > 0) && (
    <RenderableEntitiesComponent
      entities={renderableEntities}
      {...contentProps}
    />
  );
};

export default CombinedHighlightedEntities;
